module.exports = {
    calendar: "Calendar",
    today: "Today",
    yesterday: "Yesterday",
    last7days: "Last 7 days",
    last14days: "Last 14 days",
    delete_all: "Delete all",
    log_in: "Log in",
    save: "Save",
    close: "Close",
    today_stats: "today",
    week: "week",
    month: "month",
    year: "year",
    this_year: "This year",
    monthly: "monthly",
    daily: "daily",
    hourly: "hourly",
    add_new_object: "Add new object",
    latitude: "Latitude",
    longitude: "Longitude",
    current_password: "Current password",
    new_password: "New password",
    change_password: "Change password",
    language_select: "Language",
    last_year: "Last year",
    delete: "Delete",
    save_profile: "Save profile",
    yes: "Yes",
    cancel: "Cancel",
    add_new_group: "Add new group",
    automatic_learn: "Automatic learning",
    delete_all_imprints: "Delete all appliances imprints",
    turn_on: "Turn ON",
    turn_off: "Turn OFF",
    delete_energy: "Delete energy",
    next: "Next",
    back: "Back",
    boot_msg: "Boot message",
    force_drsf: "Force",
    add_test_case: "Add test case",
    select: "Select",
    profile: "Profile",
    group: "Group",
    start_test: "Start testing",
    generate_new_token: "Generate new token",
    generate: "Generate",
    auto_restart: "Auto restart",
    no_group: "No group",
    upgrade: "Upgrade",
    upgrade_offline: "Upgrade (device offline)",
    create_swich: "Create switch",
    change_map: "Change map",
    edit_mode: "Edit mode",
    select_image: "Select image",
    add: "Add"
}